import { Component, Output, EventEmitter } from '@angular/core';
import { ToastController, AlertController, NavController } from 'ionic-angular';
import { PrivacyComponent, LegalComponent, LicenseManagerService } from '../../shared/shared';

@Component({
    selector: 'lm-login',
    templateUrl: 'login.component.html'
})
export class LoginComponent {
    @Output() public loggedInCallback = new EventEmitter();

    username: string = '';
    password: string = '';

    constructor(private licenseManagerService: LicenseManagerService, private alertController: AlertController, private toast: ToastController, private navController: NavController) {
    }

    public didTapLoginButton() {
        this.licenseManagerService.login(this.username, this.password).subscribe((object) => {
            console.log(object);
            this.loggedInCallback.emit(object);
        }, this.licenseManagerService.handleHttpError('Login fehlgeschlagen', undefined, false));
    }

    public didTapPasswordLostButton() {
        if (this.username !== undefined && this.username.length > 0) {
            const alert = this.alertController.create({
                title: 'Passwort senden?',
                message: 'Soll eine EMail mit einem neuen Passwort an ihre hinterlegte EMail adresse gesendet werden?',
                buttons: [
                    {
                        text: 'Abbrechen',
                        role: 'cancel',
                    },
                    {
                        text: 'Senden',
                        handler: () => {
                            this.licenseManagerService.resetPassword(this.username).subscribe( () => {
                                const toast = this.toast.create({message: 'Ein Passwort wird Ihnen geschickt.', duration: 3000});
                                toast.present();
                            }, this.licenseManagerService.handleHttpError('Passwort-Vergessen-Aufruf fehlgeschlagen'));
                        }
                    }
                ]
            });
            alert.present();
        }
    }

    public didTapLegal() {
        this.navController.push(LegalComponent);
    }

    public didTapPrivacy() {
        this.navController.push(PrivacyComponent);
    }

}



// WEBPACK FOOTER //
// ./src/app/features/userManagement/loginComponent/login.component.ts